import React, {PropTypes} from 'react';

import Munchkin from '../_shared/lib/marketo';

import style from './app.scss';

class App extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
    };
  }

  componentDidMount() {
    Munchkin();
  }

  render() {
    return (
      <div className={style.body}>
        <div className={style.container}>
          <div className={style.ggLogo}></div>
          {this.props.children}
        </div>
        <div className={style.footer}>
          <div className={style.leftFooter}>
            <a target="_blank" className={style.footerLink} href="http://blog.goguardian.com/">Blog</a>
            <a target="_blank" className={style.footerLink} href="https://www.goguardian.com/policies/privacy">Privacy Policy</a>
            <a target="_blank" className={style.footerLink} href="https://www.goguardian.com/policies/eula">Terms</a>
          </div>
          <div className={style.rightFooter}>
            © { (new Date()).getFullYear() } GoGuardian. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.node
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/app/index.jsx
 **/